import { render } from "./HeartIcon.vue?vue&type=template&id=214c124c"
import script from "./HeartIcon.vue?vue&type=script&lang=js"
export * from "./HeartIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__